export const initAppcues = (onload?: HTMLScriptElement['onload']) => {
    const initSettingsScript = document.createElement('script');
    initSettingsScript.type = 'text/javascript';
    initSettingsScript.text = 'window.AppcuesSettings = { enableURLDetection: false };';
    const appcuesScript = document.createElement('script');
    appcuesScript.src = `//fast.appcues.com/${process.env.REACT_APP_APPCUES_ID}.js`;

    if (onload) appcuesScript.onload = onload;

    document.head.appendChild(initSettingsScript);
    document.head.appendChild(appcuesScript);
};
